module.exports = "<select class=\"form-control\"\n        ng-model=\"model[options.key]\"\n        ng-options=\"option[to.valueProp || 'value'] as option[to.labelProp || 'name'] group by option[to.groupProp || 'group'] for option in to.options\">\n</select>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./types/select.html
 ** module id = 22
 ** module chunks = 0
 **/